<template>
  <div class="container">
    <img src="https://info.vinapp.co/wp-content/uploads/2024/06/Logo-secundario.png" class="logo" />

    <h3>Impresora POS {{ license.name }}</h3>

    
    <div class="button-group">
      <button @click="checkWebUSB">Verificar puerto</button>
      <button @click="listUSBDevices" :disabled="disabledSelected">Conectar impresora</button>
      <button @click="searchData" :disabled="disabledTest">Página de prueba</button>
    </div>

    <!-- Estado del puerto USB -->
    <div :class="['status', usbStatus.isError ? 'error' : 'success']">
      {{ usbStatus.message }}
    </div>

    <!-- Dispositivos USB conectados -->
    <div v-if="usbDevices.length" id="deviceList">
      <h3>Dispositivos USB detectados:</h3>
      <ul>
        <li v-for="device in usbDevices" :key="device.vendorId">
          <strong>Fabricante:</strong> {{ device.manufacturerName || 'Desconocido' }}<br>
          <strong>Producto:</strong> {{ device.productName || 'Desconocido' }}<br>
          <strong>ID Vendedor:</strong> 0x{{ device.vendorId.toString(16).padStart(4, '0') }}<br>
          <strong>ID Producto:</strong> 0x{{ device.productId.toString(16).padStart(4, '0') }}
        </li>
      </ul>
    </div>

    <div class="button-group">
      <button :disabled="!selectedDevice && disabledSave" @click="savePrinter">Guardar</button>
    </div>

    <!-- Vista previa del ticket -->
    <div class="container-preview">
      <div v-if="preview" id="preview" class="preview">{{ preview }}</div>
    </div>

    <!-- Estado general -->
    <div v-if="status.message" :class="['status', status.isError ? 'error' : 'success']">
      {{ status.message }}
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { printUSB, savePrinterUSB } from "./util/print-web.js";
  
export default {
  props: ["license"],
  data() {
    return {
      selectedDevice: null,
      disabledSelected: true,
      disabledTest: true,
      disabledSave: true,
      usbDevices: [],
      preview: '',
      usbStatus: { message: '', isError: false },
      status: { message: '', isError: false },
    };
  },
  methods: {
    updateStatus(type, message, isError = false) {
      this[type] = { message, isError };
    },
    async checkWebUSB() {
      if ('usb' in navigator) {
        this.updateStatus('usbStatus', '✅ WebUSB está soportado');
        this.disabledSelected = false;
      } else {
        this.updateStatus('usbStatus', '❌ WebUSB no está soportado', true);
        this.disabledSelected = true;
      }
    },

    listUSB(){
      listUSBDevices()
    },

    async searchData() {
      try {
        const url = 'https://development.vinapp.co/api/socket-order/getDataPrintOrder/4290442';
        const res = await axios.get(url);
        
        if (!res.data.error) {
          const success = await printUSB(res.data.data);
          this.disabledSave = !success; // Habilita o deshabilita según el resultado
        } else {
          console.log('Ocurrió el siguiente error al intentar imprimir: ' + res.data.message);
          this.disabledSave = true;
        }
      } catch (err) {
        console.log(err);
        this.disabledSave = true;
      }
    },

    async listUSBDevices() {
      try {
        const device = await navigator.usb.requestDevice({ filters: [] });
        this.selectedDevice = device;
        this.usbDevices = await navigator.usb.getDevices();
        console.log({impresora: this.selectedDevice})
        console.log({impresora2: this.usbDevices})
        savePrinterUSB(device)
        this.updateStatus('usbStatus', 'Impresora conectada con éxito');
        this.disabledTest = false;
      } catch (error) {
        console.log(error.message)
        this.updateStatus('usbStatus', 'Error al conectar impresora', true);
        this.disabledTest = true;
      }
    },

    async paginaDePrueba(data) {

      if (data.bebidas.length > 0) {
        data.bebidas.forEach(item => {
          data.details.push(item);
        });
      }

      const ejemploDatos = {
        header: {
          title: 'PAGINA DE PRUEBA',
          company: `${this.license.name}`,
          nit: data.nit_business || 'No definido',
          city: data.city_point || 'VALLEDUPAR',
          phone: this.license.phone || 'No definido',
          address: this.license.address || 'No definido',
          resolution: data.resolution || 'No definida',
          prefix: 'HABILITADA DESDE 1 AL 10000 CON PREFIJO: CO'
        },
        orderNumber: data.document_number || 'No definido',
        date: data.document_date || 'No definida',
        seller: data.vendedor || 'No definido',
        customerName: data.client_name || 'No definido',
        customerNit: data.client_identification || 'No definido',
        customerAddress: data.client_address || 'No definido',
        items: [],
        service: data.service,
        shipping: data.shipping,
        subtotal: data.subtotal,
        total_discount: data.total_discount,
        tax: data.impuesto_consumo == null ? 0 : parseFloat(data.impuesto_consumo.replace('$', '').replace(',', '').trim()),
        subtotalWithTax: data.subtotal_without_imp,
        paymentMethod: data.payment_methods || 'Efectivo',
        total: data.total,
        cufe: data.tascode || 'No disponible'
      };

      // Reemplazamos el map con un ciclo for      
      for (const detail of data.details) {
        ejemploDatos.items.push({
          description: detail.product_invoice || 'Producto no disponible',
          price: detail.value,
          quantity: detail.quantity || 1
        });
      }

      this.preview = this.formatearTicket(ejemploDatos);

      try {
        await this.selectedDevice.open();
        await this.selectedDevice.selectConfiguration(1);
        await this.selectedDevice.claimInterface(0);

        const commands = new Uint8Array([
          0x1b, 0x40,
          0x1b, 0x61, 0x00,
          ...new TextEncoder().encode(this.preview),
          0x0a, 0x0a, 0x0a,
          0x1d, 0x56, 0x41, 0,
        ]);

        await this.selectedDevice.transferOut(1, commands);
        this.updateStatus('status', 'Página de prueba enviada correctamente');
      } catch (error) {
        console.log(error.message);
        this.updateStatus('status', 'Ocurrió un error al imprimir', true);
      }
    },
    savePrinter() {
      console.log('entra a guardar')
      if (this.selectedDevice) {
        const printerData = {
          vendorId: this.selectedDevice.vendorId,
          productId: this.selectedDevice.productId,
        };
        localStorage.setItem('selectedPrinter', JSON.stringify(printerData));
        setTimeout(() => {
          window.location.href = `${location.origin}${location.pathname}?kiosko`;
        }, 1000);
      } else {
        this.updateStatus('status', 'No hay impresora seleccionada', true);
      }
    },
    loadPrinter() {
      const printerData = localStorage.getItem("selectedPrinter");
      if (printerData) {
        this.selectedDevice = JSON.parse(printerData);
      }
    },
    centrarTexto(texto, ancho) {
      const partes = texto.split('\n'); // Dividir en líneas
      return partes.map(linea =>
        linea
          .padStart(linea.length + Math.floor((ancho - linea.length) / 2), ' ') // Centrar
          .padEnd(ancho, ' ') // Asegurar ancho total
      ).join('\n');
    },

    formatearTicket(datos) {
      const linea = '-'.repeat(45) + '\n';
      const anchoMax = 45;
      let ticket = '';

      // Encabezado centrado
      const encabezado = [
        datos.header.title,
        datos.header.company,
        `Nit: ${datos.header.nit}`,
        `Ciudad: ${datos.header.city}`,
        `Telefono: ${datos.header.phone}`,
        `Direccion: ${datos.header.address}`,
        datos.header.resolution,
        datos.header.prefix
      ].join('\n');

      ticket += this.centrarTexto(encabezado, anchoMax) + '\n';
      ticket += linea;

      const detalleFactura = [
        `Factura Electronica de Venta: ${datos.orderNumber}`,
        `Fecha: ${datos.date}`,
        `Vendedor: ${datos.seller}`,
        `Nombre: ${datos.customerName}`,
        `Nit: ${datos.customerNit}`,
        `Direccion: ${datos.customerAddress}`,
      ];

      detalleFactura.forEach(lineaDetalle => {
        ticket += lineaDetalle + '\n'; // Alinear a la derecha usando el ancho máximo
      });

      ticket += linea;

      // Productos (formato de columnas fijas)
      ticket += 'Descripcion               Cant       Valor\n';
      datos.items.forEach(item => {
        const descripcion = item.description.substring(0, 20).padEnd(20);
        const cantidad = item.quantity.toString().padStart(10);
        const valor = item.price.padStart(15);
        ticket += `${descripcion}${cantidad}${valor}\n`;
      });
      ticket += linea;

      // Totales alineados a la derecha
      const totales = [
        `Subtotal: ${datos.subtotalWithTax}`,
        `Imp. Consumo: ${datos.tax}`,
        `Propina: ${datos.service}`,
        `Domicilio: ${datos.shipping}`,
        `Descuento: ${datos.total_discount}`,
        `Total: ${datos.total}`,
        `Forma de pago: ${datos.paymentMethod}`,
        //`Subtotal sin Imp: ${datos.subtotal}`,
        
      ];

      totales.forEach(lineaTotal => {
        ticket += lineaTotal.padStart(anchoMax) + '\n'; // Alinear a la derecha
      });

      ticket += linea;

      // Pie de página
      const pieDePagina = [
        'Qr para descargar su factura.',
        `No. Factura Electronica: ${datos.orderNumber}`,
        `Cufe: ${datos.cufe}`,
        '',
        '¡Gracias por su compra!',
        'Impreso por VinApp'
      ];

      // Aplicar centrado a cada línea del pie de página
      const pieDePaginaCentrado = this.centrarTexto(pieDePagina.join('\n'), anchoMax);
      ticket += pieDePaginaCentrado;

      return ticket;
    },

  },
  mounted(){
    //this.checkWebUSB();
    //this.loadPrinter();
  }
};
</script>

<style scoped>
.container {
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
}
.container-preview {
  width: 55%;
  margin: 0 auto; 
  overflow: hidden; 
}

.logo {
  width: 25%;
  margin-bottom: 2rem;
  border-radius: 50%;
}
.button-group button {
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 5px;
}
.button-group button:disabled {
  background: #ccc;
}
.status {
  padding: 10px;
  margin: 10px 0;
  border-radius: 5px;
}
.success {
  background: #d4edda;
  color: #155724;
}
.error {
  background: #f8d7da;
  color: #721c24;
}
.preview {
  font-family: monospace;
  white-space: pre;
  background: #f5f5f5;
  padding: 20px;
  margin: 20px 0;
  border-radius: 5px;
  text-align: left;
  max-width: 100%; 
  word-wrap: break-word;
}

</style>
